import Vue from 'vue';
import teamMemberService from '../team_member';

const success = (response, context) => {
    $(".cancel").removeClass("disabled");
    $(".confirm").removeClass("disabled");
    let message = 'User ' + (user.active ? 'deactivated' : 'activated') + ' successfully';
    swal("Done!", message, "success");
    teamMemberService.get(context);
};

// When the request fails
const failed = (error, context) => {
    if(error.response) {
        $(".cancel").removeClass("disabled");
        $(".confirm").removeClass("disabled");
        swal("Error!", error.response.data.msg, "warning");
    }
};

export default (context, user) => {
    return Vue.$http.put('/team-members/' + user.id, user).then((response) => {
        if (response && response.status === 200) {
            success(response, context);
        }
    })
        .catch((error) => {
            failed(error,context);
        });
};



// WEBPACK FOOTER //
// ./src/app/services/account/updateTeamMembers.js